import { MortgageErrorStatus } from '@propertypal/shared/src/types/mortgages';
import React from 'react';
import { MortgageCalcContainer, ErrorText } from './MortgageCalcError.style';

interface MortgageErrorProps {
  errors?: MortgageErrorStatus;
  broker?: boolean;
  testID?: string;
}

const MortgageCalcError = (props: MortgageErrorProps) => {
  const { errors } = props;

  const determineErrorToShow = () => {
    if (errors) {
      switch (errors.error) {
        case 'DEPOSIT_GREATER_VALUE':
          return (
            <ErrorText broker={props.broker}>
              Your deposit is greater than the property value. It seems you do not require a mortgage.
            </ErrorText>
          );

        case 'DEPOSIT_EQUAL_VALUE':
          return (
            <ErrorText broker={props.broker}>
              Your deposit is the same as the property value. It seems you do not require a mortgage.
            </ErrorText>
          );

        case 'NO_RESULTS':
          return (
            <ErrorText broker={props.broker}>
              Based on your criteria, there are no mortgage products available at present.
            </ErrorText>
          );

        case 'INVALID_LTV':
          return (
            <ErrorText broker={props.broker}>
              Based on your criteria, the Loan-to-Value % for this property is less than 1%. It seems you do not require
              a mortgage.
            </ErrorText>
          );

        case 'SERVER_ERROR':
          return (
            <ErrorText broker={props.broker}>
              Oops, it looks like there has been an error on our server. Maybe try again?
            </ErrorText>
          );
        default:
          return null;
      }
    }
    return null;
  };
  return <MortgageCalcContainer data-testid={props.testID}>{determineErrorToShow()}</MortgageCalcContainer>;
};

export default MortgageCalcError;
